"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("../../Icon"));
var _Link = _interopRequireDefault(require("../../Link"));
require("./Step.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Step = _ref => {
  let {
    hasProgressLine,
    index,
    title,
    label,
    linkProps,
    enabled,
    selected = false,
    iconName,
    iconClassName,
    handleClick,
    ...props
  } = _ref;
  const stepStatusClass = enabled ? "step-enabled" : "step-disabled";
  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: (0, _classnames.default)("step", {
      "progress-line": hasProgressLine,
      "step-selected": selected
    })
  }, props), iconName === "number" ? /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)("step-number", {
      "step-number-disabled": !enabled
    })
  }, index) : /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: iconName,
    className: (0, _classnames.default)("step-status-icon", iconClassName)
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "step-content"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)(stepStatusClass),
    onClick: handleClick
  }, title), label && /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)("step-optional-content", "u-no-margin--bottom", {
      "step-disabled": !enabled
    })
  }, label), linkProps && /*#__PURE__*/_react.default.createElement(_Link.default, _extends({
    className: "p-text--small u-no-margin--bottom step-optional-content"
  }, linkProps), linkProps.children)));
};
Step.propTypes = {
  hasProgressLine: _propTypes.default.bool.isRequired,
  index: _propTypes.default.number.isRequired,
  title: _propTypes.default.string.isRequired,
  label: _propTypes.default.string,
  enabled: _propTypes.default.bool.isRequired,
  selected: _propTypes.default.bool,
  iconName: _propTypes.default.string.isRequired,
  handleClick: _propTypes.default.func.isRequired
};
var _default = exports.default = Step;